module.exports = __webpack_public_path__ + "static/media/national_social_media_addon.a457cc19.jpg";